import {
  Component,
  OnInit,
  OnDestroy,
  Inject
} from "@angular/core";
import { Router } from '@angular/router';
import { UserSessionService } from '../services/usersession.services';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormGroup, FormControl } from '@angular/forms';
import { MatTableDataSource} from '@angular/material/table';
import { Subscription } from 'rxjs';
import { IUserSession } from '../user-session/user-session-data';
import { HttpErrorResponse } from '@angular/common/http';
import { DatePipe } from "@angular/common";
import { AuthService } from 'src/app/user/services/auth.service';

@Component({
  selector: 'app-user-session',
  templateUrl: './user-session.component.html',
  styleUrls: ['./user-session.component.scss']
})
export class UserSessionComponent implements OnInit, OnDestroy {

  private subs = new Subscription();

  displayedColumns: string[] = ['iat', 'options'];
  
  public dataSource: MatTableDataSource<IUserSession>;

  private dataArray: any;

  public userForm:FormGroup; 
  errorMessage = '';
  sessVals: any;
  farmattedDate: string;
  public currCount;
  currentUser:any;
 

  constructor(private router:Router,
              private userSessionService: UserSessionService,
              private dialogRef: MatDialogRef<UserSessionComponent>,
              private datePipe: DatePipe,
              private authService: AuthService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
                this.sessVals = data;
              }

  ngOnInit() {  
    //this.loadAllUserData();
    this.dataArray = this.sessVals.sessionVals.result;
    this.dataSource = new MatTableDataSource<IUserSession>(this.dataArray);        
  }

  ngOnChanges(){
  }

  closeThisSession(session:Date): void {
    this.farmattedDate = this.datePipe.transform(
      session,
      "yyyy-MM-dd HH:mm:ss"
    );
      this.userSessionService.closeSession(this.farmattedDate).subscribe((res:any) => {

        if (res.responseStatus === "Success") {  
          const storedUser = JSON.parse(sessionStorage.getItem('currentUser'));
          var userId = storedUser.userId
          var token = storedUser.token
          var maxSession = storedUser.maxSession
          var current = storedUser.current - 1;

          this.currentUser ={
            userId,
            token,
            maxSession,
            current
        };
        sessionStorage.setItem('currentUser',JSON.stringify(this.currentUser));
          
          // const storedUser = JSON.parse(sessionStorage.getItem('currentUser'));
          // storedUser.current = storedUser.current - 1;
          const storedUser1 = JSON.parse(sessionStorage.getItem('currentUser'));

          this.sessVals.sessionVals.result.length = this.sessVals.sessionVals.result.length - 1;     
        if(this.sessVals.sessionVals.result.length < this.sessVals.maxSession) {
          this.setValidSession();
          this.dialogRef.close();
        } else {
          this.loadValidUserSessions();
        }
      }
    },
    (err: HttpErrorResponse) => {
      console.log(err);
    });    
  }

  loadValidUserSessions(): void {    
    this.userSessionService.loadValidUserSessions().subscribe((res:any) => {
      //if (res.responseStatus === "Success") {         
        this.dataArray = res;
        this.dataSource = new MatTableDataSource<IUserSession>(this.dataArray);  
    //}
  },
  (err: HttpErrorResponse) => {
    console.log(err);
  });  
  }

  cancelThisSession(): void {    
      this.userSessionService.cancelThisSession().subscribe((res:any) => {
        if (res.responseStatus === "Success") {          
          this.dialogRef.close();
          this.authService.logout();
          this.router.navigate(['/user/login']);
      }
    },
    (err: HttpErrorResponse) => {
      console.log(err);
    });    
    //this.router.navigate(['/user/login']);
  }

  closeAllValidSessions(): void {  
    //let tempArray: any[] = [];
    let list = [];
   
    this.sessVals.sessionVals.result.forEach((session) => {
      session.exp = this.datePipe.transform(
        session.exp,
        "yyyy-MM-dd HH:mm:ss"
      );
      session.iat = this.datePipe.transform(
        session.iat,
        "yyyy-MM-dd HH:mm:ss"
      );      
      //tempArray.push(session)
      list.push(session)
    });

    this.userSessionService.closeAllSessions(list).subscribe((res:any) => {
      if (res.responseStatus === "Success") { 
        const storedUser = JSON.parse(sessionStorage.getItem('currentUser'));
        var userId = storedUser.userId
        var token = storedUser.token
        var maxSession = storedUser.maxSession
        var current = 0;

        this.currentUser ={
          userId,
          token,
          maxSession,
          current
      };
      sessionStorage.setItem('currentUser',JSON.stringify(this.currentUser));
      const storedUser1 = JSON.parse(sessionStorage.getItem('currentUser'));

        this.setValidSession();
        this.dialogRef.close();      
        // const storedUser = JSON.parse(sessionStorage.getItem('currentUser'));
        // storedUser.current = 0;
    }
  },
  (err: HttpErrorResponse) => {
    console.log(err);
  });
  }

  setValidSession() {
    this.router.navigate(['/dashboard']);
  }

  continueSession() {
    this.setValidSession();
    this.dialogRef.close(); 
  }

  ngOnDestroy() {
    if (this.subs) {
      this.subs.unsubscribe();
    }
  } 
}
